import TextField from "@mui/material/TextField";
import { FormInputProps } from "../form-input";
import { FormItemLabel } from "./form-item-label";

export type TextAreaInputProps = Omit<FormInputProps, "formLayout">;

export const TextAreaInput: React.FC<TextAreaInputProps> = ({
  formItem,
  formData,
  setValue,
}) => {
  const resolvedValue = (): string => {
    const e = formData[formItem.name];
    if (!e) return "";
    else if (typeof e === "object") return JSON.stringify(e);
    else return e as string;
  };
  return (
    <div className="_textarea-input.tsx textarea-input">
      <TextField
        id={formItem.name}
        value={resolvedValue()}
        onChange={(evt) => setValue(evt.target.value)}
        disabled={formItem.disabled}
        fullWidth
        multiline
        variant="outlined"
        label={
          <FormItemLabel
            label={formItem.label ?? formItem.name}
            helpText={formItem.helpText}
          />
        }
        minRows={2}
      />
    </div>
  );
};
